import { type VerifyV3StartResponse, verifyV3Start } from '@/api/generated';

import { createRateLimitedResendMutation } from './create-rate-limited-resend-mutation';

type MutationParams = {
  phoneNumber: string;
};

const fetcher = async (params: MutationParams) => {
  const { data } = await verifyV3Start({
    body: { phone_number: params.phoneNumber },
  });

  return data;
};

export const useSmsVerifyStartMutation = createRateLimitedResendMutation<
  MutationParams,
  VerifyV3StartResponse
>({
  fetcher,
  errorMessage: 'Failed to send verification code',
  storeName: 'sms-rate-limiter',
});
